/* eslint-disable no-underscore-dangle */
import { useState, useEffect, useContext } from 'react';

import { useLazyQuery } from '@apollo/client';

import { GeneralContext } from '../../../../core/app-context/GeneralContext';
import { GET_CREDENTIALS_MEMPHIS } from './graphql';

export function useGetMemphisCredentials({ storeId } = {}) {
  const { setLoading, setErrorMessage } = useContext(GeneralContext);
  const [isLoading, setIsLoading] = useState(false);
  const [credentials, setCredentials] = useState({
    username: '',
    password: '',
  });
  const [GetMemphisCredentials, { loading: apiLoading }] = useLazyQuery(
    GET_CREDENTIALS_MEMPHIS,
    { fetchPolicy: 'network-only' },
  );

  useEffect(() => {
    if (apiLoading) {
      setIsLoading(true);
      setLoading(true);
    } else {
      setIsLoading(false);
      setLoading(false);
    }
  }, [apiLoading]);

  async function getMemphisCredentials(newStoreId) {
    try {
      const res = await GetMemphisCredentials({
        variables: { storeId: newStoreId || storeId },
      });
      if (res.data.getMemphisCredentials.code === 200) {
        const { username, password } =
          res.data.getMemphisCredentials.credentials;
        setCredentials({
          username,
          password,
        });
      } else {
        setCredentials({ username: '', password: '' });
      }
    } catch (e) {
      setErrorMessage('Algo deu errado, tente novamente mais tarde.');
    }
  }

  useEffect(() => {
    if (storeId) {
      getMemphisCredentials(storeId);
    }
  }, [storeId]);

  return {
    getMemphisCredentials,
    credentials,
    setCredentials,
    loading: isLoading,
  };
}
